
export const EnumReimbursementStatus = {
    EXCLUIDO: "EXCLUIDO",
    VALIDACAO: "VALIDACAO",
    VALIDADO: "VALIDADO",
} as const;
  